import { ConfigData } from "@lib/titan2-slingo/dist/api/model/data/ConfigData";
import { ApiConstants } from "../enum/ApiConstants";
import { FeatureConfigData } from "./FeatureConfigData";
/**
 * ExtendedConfigData.ts
 */
export class ExtendedConfigData extends ConfigData {
    solidify() {
        super.solidify();
        this.solidifyFeatureConfig();
    }
    solidifyFeatureConfig() {
        const feature = this.data.getDataObject(ApiConstants.PROPERTY_FEATURE);
        if (this.dataExists(feature)) {
            this.featureConfig = new FeatureConfigData(feature);
        }
    }
    getFeatureConfig() {
        return this.featureConfig;
    }
}
//# sourceMappingURL=ExtendedConfigData.js.map